import { createContext, useContext, useMemo, useState } from 'react';
import _ from 'lodash';

const MAX_NOTIFICATIONS_COUNT = 4;
const REMOVE_NOTIFICATION_AFTER = 4000;

const notificationsEmitContext = createContext({
  showSuccessNotification: _.noop,
  showErrorNotification: _.noop,
  showInfoNotification: _.noop
});

const notificationsContext = createContext({
  notifications: [],
  remove: _.noop
});

export const useNotifications = () => useContext(notificationsEmitContext);

export const useAvailableNotifications = () => useContext(notificationsContext);

export const NotificationsProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const notificationsValue = useMemo(
    () => ({
      notifications,
      remove: (id) => setNotifications((prevNotifications) => prevNotifications.filter((x) => x.id !== id))
    }),
    [notifications]
  );

  const addNotification = (notification) => {
    const notificationId = Date.now();

    setNotifications((prevNotifications) => [
      ...prevNotifications.slice(-MAX_NOTIFICATIONS_COUNT + 1),
      { ...notification, id: notificationId }
    ]);

    setTimeout(() => {
      setNotifications((prevNotifications) => prevNotifications.filter((n) => n.id !== notificationId));
    }, REMOVE_NOTIFICATION_AFTER);
  };

  const emitFunctions = useMemo(
    () => ({
      showSuccessNotification: ({ title = 'Success', description = 'Task completed successfully' } = {}) =>
        addNotification({ title, description, type: 'success' }),
      showErrorNotification: ({ title = 'Error', description = 'Something went wrong' } = {}) =>
        addNotification({ title, description, type: 'error' }),
      showInfoNotification: ({ title = 'Information', description }) =>
        addNotification({ title, description, type: 'info' })
    }),
    []
  );

  return (
    <notificationsContext.Provider value={notificationsValue}>
      <notificationsEmitContext.Provider value={emitFunctions}>{children}</notificationsEmitContext.Provider>
    </notificationsContext.Provider>
  );
};
